import { IBaseApiModel, IFileAttachment, INoteEvent, IPhoneNumberMetadata, IUser } from '..';

export interface IPhoneCallCategory {
	archived?: boolean;
	hexColor?: string;
	id?: string;
	name: string;
	usage?: number;
}

export enum PhoneCallDirection {
	Outbound = 'Outbound',
	Inbound = 'Inbound',
}

export enum LeadCallMode {
	Normal = 'Normal',
	PracticeCall = 'PracticeCall',
}

export interface IStoredFile {
	accountId?: string;
	composedFilePath?: string;
	fileName?: string;
	publicUrl?: string;
	regionName?: string;
	resourceType?: string;
}

export interface ICardImageFile extends IFileAttachment {
	storedFile?: IStoredFile;
}

export enum PhoneCallRecordingTranscriptionStatus {
	AvailableForTranscription = 'AvailableForTranscription',
	RecordingValidationFailure = 'RecordingValidationFailure',
	TranscriptionComplete = 'TranscriptionComplete',
	TranscriptionFailure = 'TranscriptionFailure',
}

export type CoachingStepName = 'GetToDm' | 'Hook' | 'Pitch' | 'QualifyingQuestions' | 'Close';

export type CoachingSuggestionStepName = CoachingStepName | 'Other';

export type CoachingClassification = 'followed' | 'not_followed' | 'not_applicable';

export interface ICoachingStepEvaluation {
	step: CoachingStepName;
	classification: CoachingClassification;
}

export interface ICoachingSuggestionEvaluation {
	step: CoachingSuggestionStepName;
	classification: CoachingClassification;
	reasoning: string;
}

export interface ICoachingAdherenceResult {
	score: number;
	closeScore: number;
	getToDmScore: number;
	hookScore: number;
	pitchScore: number;
	qualifyingQuestionsScore: number;
	evaluatedDate: string;
	stepEvaluations: ICoachingStepEvaluation[];
	suggestionEvaluations: ICoachingSuggestionEvaluation[];
	summary: string;
}

export interface IPhoneCall extends IBaseApiModel {
	aiConversationId?: string;
	callStatus?: string;
	categories?: IPhoneCallCategory[];
	coachingAdherenceResult?: ICoachingAdherenceResult;
	companyId?: string;
	contactIds?: string[];
	creationDate?: string;
	creator?: { id: string };
	creatorPhoneNumber?: IPhoneNumberMetadata;
	direction?: PhoneCallDirection;
	duration?: number;
	endTime?: string;
	leadCallMode?: LeadCallMode;
	phoneNumber?: IPhoneNumberMetadata;
	recording?: IStoredFile;
	recordingChannels?: number;
	recordingTranscriptionStatus?: PhoneCallRecordingTranscriptionStatus;
	startTime?: string;
	transcriptionId?: string;
}

export enum TranscriptionStatusFilter {
	TranscriptionComplete = 'TranscriptionComplete',
	TranscriptionAvailable = 'TranscriptionAvailable',
}

export enum DealStageOptions {
	AppointmentNoShow = 'Appointment No Show',
	AppointmentRescheduled = 'Appointment Rescheduled',
	AppointmentScheduled = 'Appointment Scheduled',
	ClosedLost = 'Closed Lost',
	ClosedWon = 'Closed Won',
}

export enum DemoStatusFilter {
	DemosToConfirm = 'DemosToConfirm',
	DemosToReschedule = 'DemosToReschedule',
	UpcomingDemos = 'UpcomingDemos',
	PastDemos = 'PastDemos',
}

export enum TranscriptionStatus {
	Failed = 'Failed',
	InProgress = 'InProgress',
	Queued = 'Queued',
	Completed = 'Completed',
	Unknown = 'Unknown',
	Available = 'Available',
}

export enum TranscriptionProvider {
	Amazon = 'Amazon',
}

export interface ITranscription extends IBaseApiModel {
	creationDate?: string;
	creator?: IUser;
	id?: string;
	lastModifiedDate?: string;
	numberOfChannels?: number;
	read?: boolean;
	status?: TranscriptionStatus;
	transcriptionProvider?: TranscriptionProvider;
	transcriptionProviderId?: string;
}

export interface ISpeakerLine {
	speaker: string;
	line: string;
	startTimeOffset: number;
	endTimeOffset: number;
}

export interface ITranscriptionSpeakerLines extends IBaseApiModel {
	speakerLines: ISpeakerLine[];
	transcriptionId?: string;
	transcriptionViewType?: string;
}

export interface IPhoneCallCompletedEvent extends INoteEvent {
	phoneCall?: IPhoneCall;
}
